import {
  Breadcrumbs,
  Button,
  CircularProgress,
  Link,
  Paper,
  TextField,
  Typography,
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import AddComment from "@material-ui/icons/AddComment";
import SendIcon from "@material-ui/icons/Send";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import Title from "../../../Components/Title";
import { showPopupSnackbar } from "../../../redux/actions/snackbarActions";
import {
  formatTimeWithTZOffset,
  getAlertType,
  getToken,
} from "../../../Utils/Common";
import EnvSettings from "../../../Utils/EnvSettings";
import { useStyles } from "../../../Utils/Styles";

const server = EnvSettings.server;

export default function Alert(props) {
  const alert_id = props.computedMatch.params.alert_id;
  const [alertobj, setAlert] = useState();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const classes = useStyles();
  const [showAddNote, setShowAddNote] = useState(false);
  const [noteText, setNoteText] = useState("");

  let addNote = () => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
        alert_id: alert_id,
        note: noteText,
      }),
    };
    fetch(server + "/add_note", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        if (process.env.NODE_ENV !== "production") {
          console.log(result);
        }
        if (result.error) {
          dispatch(showPopupSnackbar(result));
        } else {
          setNoteText("");
          window.location.reload();
        }
      });
  };

  useEffect(() => {
    const getNotifications = () => {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token: getToken(), alert_id: alert_id }),
      };
      fetch(server + "/get_alerts", requestOptions)
        .then((res) => res.json())
        .then((result) => {
          if (process.env.NODE_ENV !== "production") {
            console.log(result);
          }
          if (result.error) {
            dispatch(showPopupSnackbar(result));
          } else {
            if (result.alerts) {
              setAlert(result.alerts[0]);
            }
          }
        });
    };
    getNotifications();
  }, [alert_id, dispatch]);

  return (
    <Paper className={classes.paper}>
      <Grid container spacing={3}>
        {alertobj ? (
          <React.Fragment>
            <Grid item xs>
              <Breadcrumbs aria-label="breadcrumb">
                <Link color="inherit" href="/alerts">
                  {t("alertDetails.alerts")}
                </Link>
                <Typography color="textPrimary">{`${t(
                  "alertDetails.alert"
                )}`}</Typography>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12}>
              <Title>{t("alertDetails.header")}</Title>
            </Grid>
            <Grid item xs={6}>
              {alertobj.message ? (
                <Typography>{alertobj.message}</Typography>
              ) : null}
              <Typography>{getAlertType(alertobj.alertType, t)}</Typography>
              <Typography>
                {formatTimeWithTZOffset(alertobj.createdAt)}
              </Typography>
            </Grid>
            {alertobj.Device ? (
              <Grid item xs={12}>
                <Title>{t("alertDetails.deviceHeader")}</Title>
                <Typography>{alertobj.Device.serialNumber}</Typography>
                <Typography>{alertobj.Device.deviceName}</Typography>
              </Grid>
            ) : null}
            {alertobj.Transport ? (
              <React.Fragment>
                <Grid item xs={12}>
                  <Title>{t("alertDetails.transportHeader")}</Title>
                  <Typography>
                    {alertobj.Transport.Device.deviceName ||
                      alertobj.Transport.Device.serialNumber}
                  </Typography>
                  <Typography>
                    {t("alertDetails.started") +
                      " " +
                      formatTimeWithTZOffset(alertobj.Transport.startTime)}
                  </Typography>
                  <Typography>
                    {t("alertDetails.ended") +
                      " " +
                      formatTimeWithTZOffset(alertobj.Transport.endTime)}
                  </Typography>
                  <Typography>
                    <Link href={"/transports/" + alertobj.Transport.id}>
                      {t("alertDetails.showTransportation")}
                    </Link>
                  </Typography>
                </Grid>
              </React.Fragment>
            ) : null}
            <Grid item xs={12}>
              <Title>{t("alertDetails.notes")}</Title>
              {alertobj.Notes && alertobj.Notes.length !== 0
                ? alertobj.Notes.map((note) => (
                    <Typography>
                      {formatTimeWithTZOffset(note.createdAt) + " " + note.text}
                    </Typography>
                  ))
                : null}
              <Button
                onClick={() => {
                  setShowAddNote(!showAddNote);
                }}
              >
                <AddComment></AddComment>
                <Typography>{t("alertDetails.addNote")}</Typography>
              </Button>
              {showAddNote ? (
                <Grid container style={{ flexDirection: "row" }}>
                  <Grid item xs={11}>
                    <TextField
                      name="note"
                      variant="outlined"
                      required
                      value={noteText}
                      fullWidth
                      id="note"
                      label={t("alertDetails.note")}
                      onChange={(e) => setNoteText(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={1} style={{ alignItems: "center" }}>
                    <Button
                      onClick={() => {
                        addNote();
                      }}
                    >
                      <SendIcon></SendIcon>
                    </Button>
                  </Grid>
                </Grid>
              ) : undefined}
            </Grid>
          </React.Fragment>
        ) : (
          <CircularProgress />
        )}
      </Grid>
    </Paper>
  );
}
